import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  pure: false,
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {

  /**
   * 
   * @param value 
   * @param predicate 
   * @returns Array of T
   * @description return Array filtered
   */
  transform<T>(value: T[], predicate: unknown | ((...arg: any[]) => T[])) {
    
    /**
     * 
     */
    if (!Array.isArray(value)) return [];

    /**
     * 
     */
    return value.filter(item => {

      if (predicate instanceof Function) return predicate(item)
      else return item == predicate
    
    })

  }

}